import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { img } from "../constants/assets";
import { SUPPORTED_LANGUAGES } from "../i18n";

function LanguageSwitcher({ variant = "navbar", className = "" }) {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const current =
    SUPPORTED_LANGUAGES.find((lang) => lang.code === i18n.language) ||
    SUPPORTED_LANGUAGES[0];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    setIsOpen(false);
  };

  const buttonClass =
    variant === "auth"
      ? "btn-cs btn-lang auth-lang-switcher"
      : "btn-cs btn-lang";

  return (
    <div
      className={`lang-switcher${className ? ` ${className}` : ""}`}
      ref={containerRef}
    >
      <button
        className={buttonClass}
        type="button"
        onClick={() => setIsOpen((open) => !open)}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        aria-label="Select language"
      >
        <span className="img-fluid">
          <img src={img("website.svg")} alt="" />
        </span>{" "}
        {current.label}
      </button>

      {isOpen && (
        <ul className="lang-switcher-dropdown" role="listbox">
          {SUPPORTED_LANGUAGES.map((lang) => (
            <li key={lang.code} role="option" aria-selected={lang.code === i18n.language}>
              <button
                type="button"
                className={`lang-switcher-option${
                  lang.code === i18n.language ? " lang-switcher-option--active" : ""
                }`}
                onClick={() => handleSelect(lang.code)}
              >
                <span className="lang-switcher-option-code">{lang.label}</span>
                <span className="lang-switcher-option-name">{lang.name}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default LanguageSwitcher;
